var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oa"},[_c('p',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.promptData.configurationName))]),_c('span',{staticClass:"amount",on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.promptData.count))]),_c('span',[_vm._v(_vm._s(_vm.promptData.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }